<script setup>
    import { ref, computed, inject } from 'vue';
    import IntroPage from '@/components/result/MLSRD-2026/IntroPage.vue';

    // 부모에서 주입받은 데이터
    const classData = inject('classData');
    const loading = inject('loading');

    // reportData를 computed로 변경하여 API 데이터 반영
    const reportData = computed(() => {
        if (!classData.value) {
            return {
                region: "서울",
                schoolName: "로딩중...",
                grade: "",
                className: "",
                studentNumber: "", 
                gender: "",     
                studentName: ""
            };
        }

        const data = classData.value;
        // 학교급별 학년 표시
        const gradeMap = { 'E': '초', 'M': '중', 'H': '고' };
        const gradeText = `${data.grade_code}`;

        return {
            region: "서울",
            schoolName: data.schul_nm || "",
            grade: gradeText,
            className: data.school_cls || "",
            studentNumber: "", 
            gender: "",     
            studentName: ""
        };
    });
</script>
<template>
    <div class="slide-inner pt-[50px]"> 
        <IntroPage reportType="teacher" :reportData="reportData"/>
    </div>
</template>
